import { useCallback, useState } from 'react';
import { ICategory } from '../../types/org';

import useAuth from '../../hook/useAuth';
import { AddIcon } from '../common/icons';
import Tabs, { Tab } from '../common/tabs/tabs';
import OrgCreateChildModal from '../org/org-create/org-create-child';
import CategoryDetail from './category-detail';
import InfoGoConfig from './infogo-config/infogo-config';
import { Card, CardBody, CardTitle } from "reactstrap";
import Button from '../common/button';

type CategoryInfoProps = {
  category: ICategory
}

const CategoryInfo = (props: CategoryInfoProps) => {
  const { category } = props
  const [orgCreateChildOpen, setOrgCreateChildOpen] = useState<boolean>(false)
  const { isAdmin,isFrenchTranslator } = useAuth();

  const toggleOrgCreateChild = useCallback(() => {
    setOrgCreateChildOpen(!orgCreateChildOpen)
  }, [orgCreateChildOpen])

  const getTabs = () => {
    const tabs: Tab[] = [
      {
        title: 'Category Details', content:
          <>
            <div>
             {isAdmin && <Button color='primary'
                onClick={toggleOrgCreateChild}>
                <AddIcon />
                &nbsp;Create Child Organization
              </Button>} 
            </div>

            <CategoryDetail category={category} />
          </>
      }
    ]

     if (isAdmin || isFrenchTranslator) {
      tabs.push({ title: 'INFO-GO Configuration', content: <InfoGoConfig category={category}></InfoGoConfig> })
     }
    return tabs
  }

  return (
    <>
      {
        <OrgCreateChildModal parent={category} isOpen={orgCreateChildOpen} toggle={toggleOrgCreateChild}></OrgCreateChildModal>
      }

      <Card >
        <CardBody>
          <CardTitle className="mb-0">
            <h2 className="h2-buttons">Category: {category?.categoryName}</h2>
          </CardTitle>

          <Tabs tabs={getTabs()} />
        </CardBody>
      </Card>
    </>
  )
}

export default CategoryInfo
